import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=38f2bb2e&scoped=true"
import script from "./Commission.vue?vue&type=script&lang=js"
export * from "./Commission.vue?vue&type=script&lang=js"
import style0 from "./Commission.vue?vue&type=style&index=0&id=38f2bb2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2bb2e",
  null
  
)

export default component.exports